document.addEventListener('DOMContentLoaded', () => {
  // --- The Engine that powers all seasonal effects ---
  class SeasonalEffects {
    constructor() {
      // Find the necessary elements on the page
      this.container = document.getElementById('seasonal-effects-container');
      this.body = document.body;
      const settingsEl = document.getElementById('seasonal-settings-json');
      
      // If the container or settings don't exist, do nothing.
      if (!this.container || !settingsEl) {
        return;
      }
      
      this.settings = JSON.parse(settingsEl.textContent);
      this.effectType = this.body.dataset.seasonalEffect;

      // Based on the effect type, call the correct function
      if (this.effectType) {
        this.init();
      }
    }

    init() {
      // The "router" that selects which effect to run
      switch(this.effectType) {
        case 'snow':
            this.createSnowfall();
            break;
        case 'leaf':
            this.createFallingLeaves();
            break;
        case 'petal':
            this.createFloatingPetals();
            break;
        case 'sparkle':
            this.createGoldenSparkles();
            break;
      }
    }

    // A helper function to get a random number in a range
    randomize(min, max) {
      return Math.random() * (max - min) + min;
    }

    /* ============================================= */
    /* ======      1. CREATE SNOWFALL         ====== */
    /* ============================================= */
    createSnowfall() {
      const intensity = this.settings.seasonal_effects_winter_intensity;
      const baseDuration = this.settings.seasonal_effects_winter_speed;
      const color = this.settings.seasonal_effects_winter_color;
      const animationTypes = ['snowfall-A', 'snowfall-B', 'snowfall-C']; // Our new animation names

      const flakeCount = Math.floor(intensity * 1.5);
      if (flakeCount === 0) return;

      for (let i = 0; i < flakeCount; i++) {
          const flake = document.createElement('div');
          flake.className = 'particle snow';

          // --- NEW DEPTH LOGIC ---
          // 'depth' will be a number between 0 (far) and 1 (close)
          const depth = this.randomize(0.1, 1);
          
          // --- Randomize properties based on depth ---
          // Far away flakes are smaller, closer flakes are larger
          const size = (depth * 6) + 2; // This calculates size from 2.6px to 8px
          
          // Closer flakes are more opaque
          const opacity = (depth * 0.6) + 0.3; // Opacity from 0.36 to 0.9

          // Far away flakes are slower, closer flakes are faster
          // We invert the depth value so smaller depth means longer duration
          const duration = baseDuration / depth;
          
          // Randomly pick one of our three animation paths
          const animationName = animationTypes[Math.floor(Math.random() * animationTypes.length)];

          // --- Standard randomization ---
          const startingLeft = this.randomize(0, 100);
          const animationDelay = this.randomize(0, duration);

          // --- Apply all styles to the snowflake ---
          flake.style.width = `${size}px`;
          flake.style.height = `${size}px`;
          flake.style.left = `${startingLeft}vw`;
          flake.style.opacity = opacity; // This sets the max opacity, animation handles the fades
          flake.style.backgroundColor = color;
          flake.style.animationName = animationName;
          flake.style.animationDelay = `${animationDelay}s`;
          flake.style.animationDuration = `${duration}s`;

          // NEW: Apply blur to distant flakes for added realism
          if (depth < 0.5) {
              const blurAmount = (1 - (depth / 0.5)) * 1.5; // Flakes with depth < 0.5 get up to 1.5px of blur
              flake.style.filter = `blur(${blurAmount}px)`;
          }
          
          this.container.appendChild(flake);
      }
    }

    /* ============================================= */
    /* ======    2. CREATE FALLING LEAVES     ====== */
    /* ============================================= */
    createFallingLeaves() {
    const intensity = this.settings.seasonal_effects_autumn_intensity;
    const baseDuration = this.settings.seasonal_effects_autumn_speed;
    const colors = this.settings.seasonal_effects_autumn_colors.split(',').map(c => c.trim());
    const animationTypes = ['leaf-fall-A', 'leaf-fall-B'];
    
    const leafCount = Math.floor(intensity * 0.7); // Leaves are larger, so we need fewer
    if (leafCount === 0) return;

    for (let i = 0; i < leafCount; i++) {
        const leaf = document.createElement('div');
        leaf.className = 'particle leaf';

        const depth = this.randomize(0.3, 1); // Leaves have less depth variation than snow
        const size = (depth * 15) + 5; // Size from ~9px to 20px
        const duration = baseDuration / depth;
        const animationName = animationTypes[Math.floor(Math.random() * animationTypes.length)];
        const startingLeft = this.randomize(0, 100);
        const animationDelay = this.randomize(0, duration);
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        
        leaf.style.width = `${size}px`;
        leaf.style.height = `${size}px`;
        leaf.style.left = `${startingLeft}vw`;
        leaf.style.animationName = animationName;
        leaf.style.animationDelay = `${animationDelay}s`;
        leaf.style.animationDuration = `${duration}s`;
        
        // Use the filter converter to apply the color
        const colorFilter = this.hexToCssFilter(randomColor);
        leaf.style.filter = colorFilter.filter.slice(0, -1); // Remove trailing semicolon

        this.container.appendChild(leaf);
    }
    }

    /* ============================================= */
    /* ======   HEX TO CSS FILTER CONVERTER     ====== */
    /* A helper utility to colorize our SVG leaf   */
    /* Source: https://github.com/element-fi/spsa-filter */
    /* ============================================= */
    hexToCssFilter(hex) {
        // HextoRGB converter
        function hexToRgb(hexString) {
          const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          const newHexString = hexString.replace(shorthandRegex, (m, r, g, b) => {
            return r + r + g + g + b + b;
          });
          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(newHexString);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }

        class Color {
            constructor(r, g, b) { this.set(r, g, b); }
            set(r, g, b) {
                this.r = this.clamp(r); this.g = this.clamp(g); this.b = this.clamp(b);
            }
            hueRotate(angle = 0) {
                angle = angle / 180 * Math.PI; const sin = Math.sin(angle); const cos = Math.cos(angle);
                this.multiply([
                    0.213 + cos * 0.787 - sin * 0.213, 0.715 - cos * 0.715 - sin * 0.715, 0.072 - cos * 0.072 + sin * 0.928,
                    0.213 - cos * 0.213 + sin * 0.143, 0.715 + cos * 0.285 + sin * 0.140, 0.072 - cos * 0.072 - sin * 0.283,
                    0.213 - cos * 0.213 - sin * 0.787, 0.715 - cos * 0.715 + sin * 0.715, 0.072 + cos * 0.928 + sin * 0.072,
                ]);
            }
            grayscale(value = 1) {
                this.multiply([
                    0.2126 + 0.7874 * (1 - value), 0.7152 - 0.7152 * (1 - value), 0.0722 - 0.0722 * (1 - value),
                    0.2126 - 0.2126 * (1 - value), 0.7152 + 0.2848 * (1 - value), 0.0722 - 0.0722 * (1 - value),
                    0.2126 - 0.2126 * (1 - value), 0.7152 - 0.7152 * (1 - value), 0.0722 + 0.9278 * (1 - value),
                ]);
            }
            sepia(value = 1) {
                this.multiply([
                    0.393 + 0.607 * (1 - value), 0.769 - 0.769 * (1 - value), 0.189 - 0.189 * (1 - value),
                    0.349 - 0.349 * (1 - value), 0.686 + 0.314 * (1 - value), 0.168 - 0.168 * (1 - value),
                    0.272 - 0.272 * (1 - value), 0.534 - 0.534 * (1 - value), 0.131 + 0.869 * (1 - value),
                ]);
            }
            saturate(value = 1) {
                this.multiply([
                    0.213 + 0.787 * value, 0.715 - 0.715 * value, 0.072 - 0.072 * value,
                    0.213 - 0.213 * value, 0.715 + 0.285 * value, 0.072 - 0.072 * value,
                    0.213 - 0.213 * value, 0.715 - 0.715 * value, 0.072 + 0.928 * value,
                ]);
            }
            multiply(matrix) {
                const newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
                const newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
                const newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
                this.r = newR; this.g = newG; this.b = newB;
            }
            clamp(value) { return Math.max(0, Math.min(value, 255)); }
        }

        class Solver {
            constructor(target) {
                this.target = target; this.reusedColor = new Color(0, 0, 0);
            }
            solve() {
                const result = this.solveNarrow(this.solveWide());
                return { values: result.values, loss: result.loss, filter: this.css(result.values) };
            }
            solveWide() {
                const A = 5; const C = 15; const S = [60, 180, 18000, 600, 1.2, 1.2];
                let best = { loss: Infinity };
                for (let i = 0; best.loss > 25 && i < 3; i++) {
                    const initial = [50, 20, 3750, 50, 100, 100];
                    const result = this.spsa(A, C, S, i * 25, 5000, initial);
                    if (result.loss < best.loss) { best = result; }
                }
                return best;
            }
            solveNarrow(wide) {
                const A = wide.loss; const C = 2; const A1 = A + 1; const S = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
                return this.spsa(A, C, S, 0, 1000, wide.values);
            }
            spsa(A, C, S, start, max, initial) {
              const T = A / Math.pow(max + 1, 0.602);
              let U = initial ? [...initial] : [50, 20, 3750, 50, 100, 100]; // Ensure U is always an array
              for (let V = start; V < max; V++) {
                  const W = [0, 0, 0, 0, 0, 0].map(() => Math.round(Math.random()) * 2 - 1);
                  const Y = U.map((AB, X) => AB + C / Math.pow(V + 1, 1.01) * W[X] * S[X]);
                  const Z = U.map((AB, X) => AB - C / Math.pow(V + 1, 1.01) * W[X] * S[X]);
                  const AA = Math.pow(V, 0.101); 
                  const BA = (this.loss(Y) - this.loss(Z)) / (2 * C / Math.pow(V + AA, 1.01));
                  const CA = W.map((X) => X * S[X]);
                  U = U.map((AB, X) => AB - T * BA / Math.pow(V + A, 0.602) * CA[X]);
              }
              return { values: U, loss: this.loss(U) };
            }
            loss(filters) {
                this.reusedColor.set(0, 0, 0);
                this.reusedColor.saturate(filters[3] / 100);
                this.reusedColor.hueRotate(filters[4] * 3.6);
                this.reusedColor.sepia(filters[2] / 100);
                this.reusedColor.grayscale(filters[1] / 100);
                return Math.abs(this.reusedColor.r - this.target.r) +
                       Math.abs(this.reusedColor.g - this.target.g) +
                       Math.abs(this.reusedColor.b - this.target.b);
            }
            css(filters) {
                const sepia = filters[2] / 100; const saturate = filters[3] / 100; const hueRotate = filters[4] * 3.6;
                const brightness = filters[0] / 100; const contrast = filters[5] / 100;
                return `filter: sepia(${sepia}) saturate(${saturate}) hue-rotate(${hueRotate}deg) brightness(${brightness}) contrast(${contrast});`;
            }
        }
        
        const rgb = hexToRgb(hex);
        if (!rgb) { return { filter: '' }; }
        const color = new Color(rgb.r, rgb.g, rgb.b);
        const solver = new Solver(color);
        return solver.solve();
    }

    /* ============================================= */
    /* ======    3. CREATE FLOATING PETALS    ====== */
    /* ============================================= */
    createFloatingPetals() {
      const intensity = this.settings.seasonal_effects_spring_intensity;
      const baseDuration = this.settings.seasonal_effects_spring_speed;
      const colors = this.settings.seasonal_effects_spring_colors.split(',').map(c => c.trim());
      const animationTypes = ['petal-float-A', 'petal-float-B', 'petal-float-C'];

      const petalCount = Math.floor(intensity * 0.8);
      if (petalCount === 0) return;

      for (let i = 0; i < petalCount; i++) {
        const petal = document.createElement('div');
        petal.className = 'particle petal';

        const depth = this.randomize(0.4, 1);
        const width = (depth * 8) + 4;  // Width from 7.2px to 12px
        const height = width * 1.6;     // Maintain petal aspect ratio
        
        const duration = (baseDuration * 1.5) / depth; // Petals are light and slow
        const animationName = animationTypes[Math.floor(Math.random() * animationTypes.length)];
        const startingLeft = this.randomize(-10, 90); // Allow starting off-screen
        const animationDelay = this.randomize(0, duration);
        const randomColor = colors[Math.floor(Math.random() * colors.length)];

        petal.style.width = `${width}px`;
        petal.style.height = `${height}px`;
        petal.style.left = `${startingLeft}vw`;
        petal.style.backgroundColor = randomColor; // Simple color change
        petal.style.animationName = animationName;
        petal.style.animationDelay = `${animationDelay}s`;
        petal.style.animationDuration = `${duration}s`;

        // Varying rotation at the start for a more natural look
        petal.style.transform = `rotateZ(${this.randomize(0, 360)}deg)`;
        
        if (depth < 0.6) {
          petal.style.filter = `blur(1px)`;
        }

        this.container.appendChild(petal);
      }
    }

    /* ============================================= */
    /* ======   4. CREATE GOLDEN SPARKLES     ====== */
    /* ============================================= */
    createGoldenSparkles() {
      const intensity = this.settings.seasonal_effects_summer_intensity;
      const baseDuration = this.settings.seasonal_effects_summer_speed;
      const colors = this.settings.seasonal_effects_summer_colors.split(',').map(c => c.trim());
      const riseAnimationTypes = ['sparkle-rise-A', 'sparkle-rise-B'];
      
      const sparkleCount = Math.floor(intensity * 1.2);
      if (sparkleCount === 0) return;

      for (let i = 0; i < sparkleCount; i++) {
        const sparkle = document.createElement('div');
        sparkle.className = 'particle sparkle';
        
        // --- Properties are NOT based on depth for a more uniform magical feel ---
        const size = this.randomize(1, 4);
        const duration = this.randomize(baseDuration * 0.8, baseDuration * 1.2);
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        
        // --- UPWARDS MOVEMENT LOGIC ---
        // Animation to rise up from the bottom
        const riseAnimationName = riseAnimationTypes[Math.floor(Math.random() * riseAnimationTypes.length)];
        const startingLeft = this.randomize(0, 100);
        // Start from the bottom of the screen (100vh) or just below it
        const startingTop = this.randomize(90, 110); 
        const animationDelay = this.randomize(0, duration);
        
        // --- Twinkle animation runs separately and at its own pace ---
        const twinkleDuration = this.randomize(2, 5);
        
        sparkle.style.width = `${size}px`;
        sparkle.style.height = `${size}px`;
        sparkle.style.left = `${startingLeft}vw`;
        sparkle.style.top = `${startingTop}vh`;
        sparkle.style.backgroundColor = randomColor;
        
        // Set the color for the glow effect. We convert the hex to rgb for the shadow.
        const rgbColor = randomColor.match(/\w\w/g).map((c) => parseInt(c, 16));
        sparkle.style.boxShadow = `0 0 8px 2px_rgba(${rgbColor.join(',')}, 0.5)`;

        // Apply TWO animations: one for rising, one for twinkling
        sparkle.style.animation = `
          ${riseAnimationName} ${duration}s ${animationDelay}s linear infinite,
          twinkle ${twinkleDuration}s ${animationDelay}s ease-in-out infinite
        `;
        
        this.container.appendChild(sparkle);
      }
    }

  } // End of SeasonalEffects Class

  // Create an instance of the class to run the engine
  new SeasonalEffects();
});